import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M17 9a1.5 1.5 0 00-3 0v5.5a1.5 1.5 0 001.5 1.5h5a1.5 1.5 0 000-3H17V9zm-6.5 13.5a1.5 1.5 0 003 0v-5A1.5 1.5 0 0012 16H7a1.5 1.5 0 000 3h3.5v3.5z" /></svg>);